/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Field_PricingInputs */

const en_agent_authorization_field_pricing = /** @type {(inputs: Agent_Authorization_Field_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const zh_agent_authorization_field_pricing = /** @type {(inputs: Agent_Authorization_Field_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定价方式`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Agent_Authorization_Field_PricingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_field_pricing = /** @type {((inputs?: Agent_Authorization_Field_PricingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Field_PricingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_field_pricing(inputs)
	return zh_agent_authorization_field_pricing(inputs)
});
export { agent_authorization_field_pricing as "agent.authorization.field.pricing" }